export default __webpack_public_path__ + "static/media/ISCO CLASS-8_SYLLABUS_2025-26.724cb0b3.pdf";